import { FunctionComponent } from "react";
import { CheckBoxPropagateColorProps } from "./checkbox-propagate-color.style";
import * as Styled from "./checkbox-propagate-color.style";
import { Term } from "@definitions";
import { useUiData } from "src/ui/data";

const checkboxLabelTerm: Term = "applyColorToAll:checkbox:title";
export const CheckBoxPropagateColor: FunctionComponent<
	CheckBoxPropagateColorProps
> = (props) => {
	const { onValueChange: onValueChangeFromProps } = props;
	const { localizer } = useUiData();

	const onValueChange = (newVal: boolean) => {
		if (newVal) {
			//applyActiveProductColorToAll();
		}

		onValueChangeFromProps?.(newVal);
	};

	return (
		<Styled.CheckBox
			{...props}
			label={localizer.localizeTerm(checkboxLabelTerm)}
			onValueChange={onValueChange}
		/>
	);
};
